export const actionTypes = {
  SET_ALLERGIES_IS_LOADING: 'MEMBERS/SET_ALLERGIES_IS_LOADING',
  FETCH_ALLERGIES: 'MEMBERS/FETCH_ALLERGIES',
  UPDATE_ALLERGIES: 'MEMBERS/UPDATE_ALLERGIES',
  RESET_ALLERGIES: 'MEMBERS/RESET_ALLERGIES',
};
